import { render, staticRenderFns } from "./LKCountsPieChart.vue?vue&type=template&id=1640c9e0&"
import script from "./LKCountsPieChart.vue?vue&type=script&lang=js&"
export * from "./LKCountsPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports